import { useEffect } from 'react';
import { useBackground } from '../contexts/BackgroundContext';

// Simple trigger word: "background"
const TRIGGER_WORD = 'background';

export const useEasterEgg = () => {
  const { toggleEasterEgg, isEasterEggActive, showNotification } = useBackground();

  useEffect(() => {

    let typedSequence = '';
    let sequenceTimer: NodeJS.Timeout;

    const handleKeyDown = (event: KeyboardEvent) => {
      // Ignore special keys and undefined keys
      if (!event.key || event.key.length > 1) return;
      
      // Clear the sequence if too much time has passed
      clearTimeout(sequenceTimer);
      
      // Add the current key to the sequence
      typedSequence += event.key.toLowerCase();
      
      // Keep only the last characters up to trigger word length
      if (typedSequence.length > TRIGGER_WORD.length) {
        typedSequence = typedSequence.slice(-TRIGGER_WORD.length);
      }
      
      // Check if current sequence matches trigger word
      if (typedSequence === TRIGGER_WORD) {
        toggleEasterEgg();
        
        // Show notification using React state
        const message = isEasterEggActive ? '🎨 Background controls unlocked!' : '🎨 Background controls hidden!';
        showNotification(message);
        
        // Reset sequence
        typedSequence = '';
      }
      
      // Reset sequence after 3 seconds of inactivity
      sequenceTimer = setTimeout(() => {
        typedSequence = '';
      }, 3000);
    };

    // Add event listener
    document.addEventListener('keydown', handleKeyDown);

    // Cleanup
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      clearTimeout(sequenceTimer);
    };
  }, [toggleEasterEgg, isEasterEggActive, showNotification]);

  return { isEasterEggActive };
};